// import { t } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

export function HeadingSection({ title, headingStyle }) {
  const { t } = useTranslation();
  return (
    <div className="container  px-5 pb-1 my-2 pt-4 ">
      <div className="flex items-center flex-col-reverse justify-center md:justify-between md:flex-row">
        <div>
          <hr className=" border-t-2 border-gray-400 w-40 h-4 md:w-38 lg:w-96" />
        </div>
        <div data-aos="fade-down" data-aos-once="true" data-aos-easing="ease-in-sine" data-aos-once="true" data-aos-offset="0">
          <h2 className={`text-2xl pb-3 font-bold text-center ${headingStyle}`}>{t(`${title}`)}</h2>
        </div>
        <div>
          <hr className=" border-t-2 border-gray-400 w-40 h-4 md:w-38 lg:w-96" />
        </div>
      </div>
    </div>
  );
}
